import { Link } from "react-router-dom";
import { LockKey } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess, planNameForLevel } from "@/lib/plans";

export const PlanGate = ({ required, children, planName }) => {
  const { user } = useAuth();
  if (canAccess(user, required)) return children;
  return <Paywall planName={planName || planNameForLevel(required)} />;
};

export const Paywall = ({ planName = "AS EVOLUTION", compact = false }) => (
  <div
    className={
      compact
        ? "as-card !p-8 text-center"
        : "min-h-[60vh] flex items-center justify-center px-4 py-16"
    }
    data-testid="paywall"
  >
    <div className={compact ? "" : "max-w-md text-center as-card !p-10"}>
      <LockKey size={compact ? 40 : 64} weight="duotone" color="#39FF14" className="mx-auto mb-5" />
      <p className="as-label text-as-green mb-3">CONTENIDO PREMIUM</p>
      <h2 className="as-heading text-2xl sm:text-3xl text-white mb-3">
        REQUIERE PLAN <span className="text-as-green">{planName}</span>
      </h2>
      <p className="text-as-gray mb-8 text-sm">
        Este módulo está disponible para clientes con plan {planName} o superior.
      </p>
      <Link to="/planes" className="as-btn-primary" data-testid="paywall-cta">
        Comprar plan
      </Link>
    </div>
  </div>
);
